var btn = document.querySelector('.x-btn.btn-icon');

var page = window.location.search.substr(1);
var scrollToPricing =
  page && page.split('&').some(v => v === 'scrollTo=pricing');

if (scrollToPricing) document.querySelector('.screen-4p5').scrollIntoView();

function changeBehavior(btn) {
  btn.addEventListener('click', function(e) {
    location.replace('https://x.razorpay.com/');
  });
}
let totalBtns = Array.from(document.querySelectorAll('.x-btn.btn-icon'));
totalBtns.push(document.querySelector('.nav-early-access'));
totalBtns.push(document.querySelector('.customBtn'));
totalBtns.forEach(function(v) {
  changeBehavior(v);
});
